module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"associate":"Associate","associateArticle":"Associate article","associateSite":"Associate site","associated":"Associated","associatedWith":"Associated with","dissociate":"Dissociate","site":"Site"}}')
  delete Component.options._Ctor
}
